<template>
    <component
        :is="this.fieldComponent"
        :filterKey="filterKey"
        :field="field"
    />
</template>

<script>
import { mapState, mapActions } from 'pinia'
import { useFilterStore } from "../../stores/filter";

export default {
  name: "Field",
  props: {
    fieldKey: String,
    filterKey: String
  },
  computed: {
    ...mapState(useFilterStore, ['findField']),
    field() {
      return this.findField(
        this.filterKey,
        this.fieldKey
      );
    },
    fieldComponent() {
      return this.field.type + `Field`;
    }
  }
}
</script>

<style lang="scss">

</style>
